import { Injectable } from '@angular/core';
import { TestRouteInterface } from '@pages/test-route-page/models/test-route.model';
import { ContactPersonInterface } from 'src/interfaces/contact-person.interface';

import { Adapter } from './adapter';

export interface TestRouteResponse {
  id: string;
  type: string;
  visible_title: string;
  title: string;
  sub_title: string;
  day_number: number;
  text: { value: string } | null;
  cities: number;
  curves: number;
  highways: number;
  landscapes: number;
  roads: number;
  distance_in_minutes: number;
  distance_in_km: number;
  stroke_color: {
    color: string;
    opacity: number | null;
  };
  geojson_data: string;
}

@Injectable({
  providedIn: 'root',
})
export class TestRouteAdapter implements Adapter<ContactPersonInterface> {
  public parse(data: TestRouteResponse): TestRouteInterface {
    return {
      id: data.id,
      title: data.visible_title || data.title,
      subtitle: data.sub_title,
      text: data.text?.value || '',
      cities: data.cities,
      curves: data.curves,
      day: data.day_number,
      minutes: data.distance_in_minutes,
      km: data.distance_in_km,
      highways: data.highways,
      landscapes: data.landscapes,
      roads: data.roads,
      color: data.stroke_color,
      geojsonData: data.geojson_data ? JSON.parse(data.geojson_data) : null,
    };
  }
}
